// components/Modal.jsx
import React from "react";
import { Bold } from 'lucide-react';
import "../css/Infomark.css";

function InfoMark({ info, setlang }) {
  return (
    <div className={setlang==="en"?"info-overlay-en":"info-overlay-fa"}>
      <p>{info}</p>
    </div>
  );
} export default InfoMark
